{
  "it": {
    "modal": {
      "actions": {
        "add": "Assegna questo cliente a questa unità",
        "approve": "Approva",
        "assign": "Assegna a questa unità",
        "assign_SUP": "Assegna a questo progetto",
        "block": "Blocca",
        "cancel": "Annulla",
        "close": "Chiudi",
        "contact_ziggu": "Contatta Ziggu",
        "giveAccess": "Concedi accesso online",
        "goBack": "Torna indietro",
        "gotIt": "Capito",
        "loading": "Caricamento",
        "next": "Avanti",
        "no": "No",
        "remove": "Elimina",
        "select_rights": "Seleziona diritti",
        "send": "Invia invito via email",
        "sendFeedback": "Invia feedback",
        "skip": "Salta",
        "submit": "Salva",
        "submitting": "Salvataggio",
        "uploading": "Caricamento",
        "yes": "Sì"
      },
      "labels": {
        "areYouSure": "È sicuro?",
        "areYouSureDelete": "È sicuro di voler eliminare {object}?",
        "assignCustomerToUnitMessagePermanently": "{customer} è già stato invitato sulla piattaforma. Assegnando questa unità, avrà accesso immediato.",
        "assignCustomerToUnitTitlePermanently": "Assegnare {customer} permanentemente a {unit}?",
        "assignTodoListToLevel": "Sta per assegnare l'elenco di attività {object} al livello {level}. Continuare?",
        "dangerZone": "Zona pericolosa",
        "deleteCustomerMessage": "Questa persona perderà tutto l'accesso alla piattaforma e quindi tutti i documenti, le FAQ, le conversazioni, le novità ecc.",
        "deleteCustomerTitle": "È sicuro di voler eliminare il cliente {customer}?",
        "deleteDecisionsBulk": "È sicuro di voler eliminare {amount} decisioni?",
        "deleteDeniedMessage": "Questo cliente ha almeno un'unità assegnata. Rimuova prima le unità assegnate per poter eliminare questo cliente.",
        "deleteDeniedTitle": "Eliminazione non consentita per {customer}",
        "deleteEmployeeSubMessage": "Disattivi invece questo utente se desidera conservare tutte le sue informazioni.",
        "deleteEmployeeTitle": "È sicuro di voler eliminare {employee}?",
        "deleteLeadMessage": "Se questo lead era interessato a un'unità, questi dati andranno persi. Se il lead ha acquistato un'unità ed è diventato cliente, il cliente e i suoi dati verranno mantenuti.",
        "deleteLeadTitle": "È sicuro di voler eliminare il lead {lead}?",
        "goToProposal": "Vai a {proposal_name}",
        "gotItMessage": "Ok, capito",
        "loading": "Il file è in fase di caricamento, attenda. La schermata di caricamento si chiuderà automaticamente.",
        "noUnitSelected": "Ops, nessuna unità selezionata",
        "noUnitSelectedMessage": "Selezioni l'unità per la quale desidera creare una segnalazione",
        "notPossible": "Non possibile",
        "ohNo": "Oh no",
        "removeCustomerDeleteInfo1": "Le conversazioni a cui il cliente ha partecipato verranno eliminate",
        "removeCustomerDeleteInfo2": "I questionari relativi a questa unità verranno eliminati",
        "removeCustomerDeleteInfo3": "I documenti caricati dal cliente all'interno di conversazioni, decisioni o proposte verranno eliminati. Questo include anche le versioni firmate dei documenti.",
        "removeCustomerKeepInformation": "I documenti generali e qualsiasi altro contenuto pubblicato in questa unità rimarranno invariati e saranno visibili a un nuovo cliente.  ",
        "removeCustomerMessage": "{customer} ha avuto accesso completo a questa unità. Se rimuove il cliente, tutti i contenuti di {customer} verranno eliminati. Questo significa… ",
        "removeCustomerMessageNth": "Se rimuove questo cliente, i contenuti creati da {customer} verranno scollegati da {customer}. Questo significa che i contenuti saranno conservati, ma non saranno più attribuiti a {customer}.",
        "removeMessage": "È sicuro di voler rimuovere {level}? In questo modo perderà tutti i dati salvati relativi a questo {type}. Non sarà possibile recuperarli in seguito.",
        "removeTitle": "Rimuovi {record_name}",
        "revokeAccessMessage": "Sta per revocare l'accesso di {customer} a questa unità. Se questa è l'unica unità assegnata al cliente, perderà completamente l'accesso alla piattaforma. ",
        "setCustomerMessage": "Bene. Sta per assegnare {customer} a {unit}. {customer} non avrà ancora accesso completo alla piattaforma. Ma può cambiarlo concedendo l'accesso una volta assegnata questa unità. ",
        "setCustomerMessageSUP": "Bene. Sta per assegnare {customer} a {unit}. {customer} non avrà ancora accesso completo alla piattaforma. Ma può cambiarlo concedendo l'accesso una volta assegnato questo progetto. ",
        "setCustomerTitle": "Assegnare {customer} a {unit}?",
        "setVisibleMessage": "Perfetto. Sta per concedere a {customer} accesso completo ai documenti condivisi e alle informazioni relative a {unit}. ",
        "setVisibleTitle": "Concedere a {customer} l'accesso online a {unit}?",
        "this": "questo",
        "typeHere": "Scriva qui...",
        "typeToConfirm": "Scriva \"{confirmationInput}\" per confermare",
        "warningAreYouSure": "Attenzione. È sicuro?",
        "warningDeleteDocument": "{file_name} è stato caricato in {attachable_type}. Rimuovendolo qui, verrà rimosso anche da {attachable_type}",
        "warningDeleteDocumentApprovedProposal": "{file_name} è un documento appartenente a una proposta approvata e non può essere eliminato in questo stato. Per eliminarlo sarebbe necessario annullare l'approvazione della proposta",
        "warningDeleteDocumentLevel": "{file_name} è stato caricato nella cartella {level_type}. Rimuovendolo qui, verrà rimosso anche dalla cartella {level_type}",
        "warningDeleteDocumentMulti": "Alcuni dei documenti che desidera eliminare sono stati caricati in una decisione o in una conversazione. Rimuovendoli qui, verranno rimossi anche dalla decisione o dalla conversazione"
      }
    }
  }
}
